import { useEffect } from "react";

import type { GetPaymentMethodsOptions } from "@jti/fe-common";
import { useDispatch } from "@jti/store/reduxHooks";
import { getPgsPaymentMethods } from "@jti/store/slices/LEGACY__checkoutSlice";

import { useOrder } from "@checkout/hooks/useOrder";

const useDispatchGetPaymentMethods = () => {
  const dispatch = useDispatch();
  const { order, orderFetchStatus } = useOrder();

  useEffect(() => {
    if (orderFetchStatus !== "success") {
      return;
    }

    const skus = order?.items?.filter((i) => !!i.sku).map((i) => i.sku);
    const options: GetPaymentMethodsOptions = { skus: skus?.length ? skus : undefined };

    dispatch(getPgsPaymentMethods(options));
  }, [dispatch, orderFetchStatus]);
};

export default useDispatchGetPaymentMethods;
